"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import { ApplicationItemModel } from "@/models/Applications.model";
import AuthorizationDialog from "./dialog/AuthorizationDialog.vue";
import API from "@ym-framework/api-utils";
import TimeFormatter from "@/framework/timeformatter";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let ApplicationItem = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this._itmeLoading = false;
    this.version = "";
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getVersion();
    });
  }
  getVersion() {
    return __async(this, null, function* () {
      let response = yield API.get(`api://base.local/update/version`);
      this.version = response.data.version;
    });
  }
  checkVersion(version, target) {
    const v1 = version.split(".").map(Number);
    const v2 = target.split(".").map(Number);
    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
      const num1 = v1[i] || 0;
      const num2 = v2[i] || 0;
      if (num1 > num2)
        return true;
      if (num1 < num2)
        return false;
    }
    return false;
  }
  addApp(app_id) {
    return __async(this, null, function* () {
      try {
        this._itmeLoading = true;
        if (this.$session.type === "account") {
          const response = yield API.put(`api://base.apps.auth/v1/personal/apps/${app_id}`);
          this.$message.success(this.$t("applicationitem.added_successfully"));
          this._item.subscribe = true;
          console.dir(response);
        }
        if (this.$session.type === "user") {
          UiConfirm.confirm(this.$t("appdetail.tip_content"), this.$t("appdetail.tip_title"));
        }
      } catch (error) {
        console.log(error);
      } finally {
        this._itmeLoading = false;
      }
    });
  }
  delApp(app_id) {
    return __async(this, null, function* () {
      try {
        this._itmeLoading = true;
        const response = yield API.delete(`api://base.apps.auth/v1/personal/apps/${app_id}`);
        this.$message.success(this.$t("applicationitem.uninstall_succeeded"));
        this._item.subscribe = false;
        console.dir(response);
      } catch (error) {
        console.log(error);
      } finally {
        this._itmeLoading = false;
      }
    });
  }
  authorization() {
    this._uthorizationDialog.open(this._item.id);
  }
  refresh() {
  }
  transfortime(time) {
    time = TimeFormatter.check(time);
    if (time === 0 || time === null) {
      return "--";
    } else {
      return TimeFormatter.dateformatterDay(time);
    }
  }
  jump(url, isNew = false) {
    return __async(this, null, function* () {
      if (url === "" || url === null || url === void 0) {
        return;
      }
      if (url.includes("rpa")) {
        if (!this.checkVersion("6.9.5", this.version)) {
          url = "https://rpa-v3.kuajingvs.com";
        }
      }
      if (isNew) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    });
  }
  tagType(color) {
    let _type = "";
    if (color === "green") {
      _type = "success";
    }
    if (color === "gray") {
      _type = "info";
    }
    if (color === "orange") {
      _type = "warning";
    }
    if (color === "red") {
      _type = "danger";
    }
    return _type;
  }
};
__decorateClass([
  PropSync("appItem", { type: ApplicationItemModel })
], ApplicationItem.prototype, "_item", 2);
__decorateClass([
  Ref("authorizationDialog")
], ApplicationItem.prototype, "_uthorizationDialog", 2);
ApplicationItem = __decorateClass([
  Component({
    components: {
      AuthorizationDialog,
      AccountSessionMixins
    }
  })
], ApplicationItem);
export {
  ApplicationItem as default
};
